import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import PageHeader from "@/components/PageHeader";
import ViewToggle, { useViewMode } from "@/components/ViewToggle";
import { Plus } from "@phosphor-icons/react";

export default function Treatments() {
    const [items, setItems] = useState([]);
    const [view, setView] = useViewMode("treatments", "list");
    useEffect(() => { api.get("/treatments").then((r) => setItems(r.data)); }, []);

    const grouped = items.reduce((acc, t) => {
        (acc[t.category] = acc[t.category] || []).push(t);
        return acc;
    }, {});

    return (
        <div className="fade-up">
            <PageHeader
                eyebrow="Tratamientos médico-estéticos"
                title="Protocolos de suplementación"
                lead="Para cada procedimiento se sugieren principios activos en tres fases: preparación, recuperación inmediata y mantenimiento."
                actions={
                    <Link to="/tratamientos/nuevo" className="btn-primary inline-flex items-center gap-2" data-testid="treatments-new-button">
                        <Plus size={14} weight="bold"/> Nuevo tratamiento
                    </Link>
                }
            />
            <div className="px-8 md:px-12 py-8 max-w-6xl">
                <div className="flex items-center justify-end mb-4">
                    <ViewToggle value={view} onChange={setView} testid="treatments-view-toggle"/>
                </div>

                {view === "list" ? (
                    <div className="surface overflow-x-auto" data-testid="treatments-list">
                        <table className="data-table w-full">
                            <thead><tr><th>Tratamiento</th><th>Categoría</th><th>Descripción</th><th>Fases</th></tr></thead>
                            <tbody>
                                {items.map((t) => {
                                    const phases = t.recommended_phases || {};
                                    const total = (phases.preparacion?.length || 0) + (phases.recuperacion?.length || 0) + (phases.mantenimiento?.length || 0);
                                    return (
                                        <tr key={t.slug} data-testid={`treatment-row-${t.slug}`}>
                                            <td><Link to={`/tratamientos/${t.slug}`} className="font-medium hover:text-[var(--sage)]">{t.name}</Link></td>
                                            <td className="text-[var(--ink-2)]">{t.category}</td>
                                            <td className="text-[var(--ink-2)] text-xs max-w-[400px] truncate">{t.description}</td>
                                            <td className="mono text-xs">{total} activos</td>
                                        </tr>
                                    );
                                })}
                                {items.length === 0 && (<tr><td colSpan={4} className="text-center text-[var(--ink-3)] py-10">Sin tratamientos</td></tr>)}
                            </tbody>
                        </table>
                    </div>
                ) : (
                    <div className="space-y-12">
                        {Object.entries(grouped).map(([cat, ts]) => (
                            <section key={cat} data-testid={`treatments-category-${cat}`}>
                                <div className="label-eyebrow mb-4">{cat}</div>
                                <div className="grid md:grid-cols-2 gap-px bg-[var(--line)] border hairline">
                                    {ts.map((t) => (
                                        <Link
                                            key={t.slug}
                                            to={`/tratamientos/${t.slug}`}
                                            className="bg-white p-6 hover:bg-[var(--cream)] transition-colors"
                                            data-testid={`treatment-card-${t.slug}`}
                                        >
                                            <h3 className="font-display text-2xl tracking-tight leading-snug mb-2">{t.name}</h3>
                                            <p className="text-sm text-[var(--ink-2)] mb-3">{t.description}</p>
                                            <div className="text-xs text-[var(--ink-3)] mono">Prep · Recup · Mant</div>
                                        </Link>
                                    ))}
                                </div>
                            </section>
                        ))}
                    </div>
                )}
            </div>
        </div>
    );
}
